import { ResponseBase } from '../Messaging/ResponseBase';

/**
 * Respond to a NotificationMessage.
 */
export class NotificationResponse extends ResponseBase {
  // NOP
}
